'use client';
import { Celebration } from '@/components/celebration';
import { useStepData } from '@/components/stepData';
import { Button, Stack, Typography } from '@mui/material';
import { success } from '@repo/onb-api';
import { COLORS, MaterialIcon, ResultScreen } from '@repo/ui';
import Link from 'next/link';

export default function SuccessCommerce({ stepdata: stepDataProp }: { stepdata?: success['variables'] }) {
  const stepData = useStepData(stepDataProp);
  const documentTypes = stepData?.documentTypes;

  return (
    <>
      <ResultScreen
        status="success"
        title="¡Ya casi estamos!"
        description="Recibimos tu solicitud. Ingresá a nuestro portal para terminar de cargar la documentación necesaria para empezar a vender con nosotros."
        actions={
          <Button
            component={Link}
            href={process.env.NEXT_PUBLIC_PROSPECTS_ROUTE || ''}
            fullWidth
            variant="contained"
            id="button-account"
          >
            Cargar documentación
          </Button>
        }
      >
        {documentTypes?.length ? (
          <Stack sx={{ alignItems: 'center', gap: 2 }}>
            <Typography component="h2" variant="h2" sx={{ color: COLORS.text.main }}>
              Importante: tené a mano la siguiente documentación para finalizar el proceso
            </Typography>
            <Stack component="ul" sx={{ gap: 1, m: 0, p: 0, listStyle: 'none', textAlign: 'left' }}>
              {documentTypes.map(({ documentType, title }) => (
                <Stack component="li" key={documentType} direction="row" sx={{ gap: 1, alignItems: 'center' }}>
                  <MaterialIcon icon="check" color="primary" aria-hidden="true" />
                  <Typography variant="body2">{title}</Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>
        ) : undefined}
      </ResultScreen>
      <Celebration />
    </>
  );
}
